export default __webpack_public_path__ + "static/media/dog7.33189760.JPG";